






























// Importing components
import TheFormLogin from '@/components/auth/TheFormLogin.vue';
import BaseAlertList from '@/ui/BaseAlertList.vue';
// Importing functions
import {validateLoginForm} from '@/ts/auth/validate-login';
import {postLogin} from '@/ts/auth/post-login';
import {getCurrentUser} from '@/ts/other/additional';


export default {
    name: 'PageLogin',
    components: {
        TheFormLogin,
        BaseAlertList,
    },
    props: {},
    data() {
        return {
            data: Object(),
            errors: Array(),
        };
    },
    mounted() {
        this.data = {
            email: '',
            password: '',
        };
        this.$store.dispatch('setLoadingOff');
    },
    methods: {
        onSubmit() {
            // Clearing the errors array
            this.errors = [];
            // Validating form
            validateLoginForm(this.errors, this.data);
            // Sending the login request
            if (this.errors.length === 0) {
                this.$store.dispatch('setLoadingOn');
                postLogin(this.errors, this.data).then(() => {
                    getCurrentUser().then((response: any) => {
                        localStorage.setItem('permissions', Array(response.permissions).join());
                        localStorage.setItem('roles', Array(response.roles).join());
                        if (response.restaurants.data.length === 0) {
                            localStorage.setItem('slug', null);
                        } else {
                            localStorage.setItem('slug', response.restaurants.data[0].id);
                        }
                    });
                    // Redirect user
                    this.$router.push({ name: 'welcome' });
                }).finally(() => {
                    this.$store.dispatch('setLoadingOff');
                });
            }
        },
    },
};
